export const exportsData = {
  options: [
    {
      id: 1,
      title: "Complete View",
      refreshed: {
        time: "09062020",
        user: "BKahn",
      },
      filename: "megafile",
    },
    {
      id: 2,
      title: "C1 Client Deliverable",
      refreshed: {
        time: "12202019",
        user: "BKahn",
      },
      filename: "",
    },
  ],
  saved: [
    {
      id: 1,
      title: "C1 Client Deliverable PURCHQ1",
    },
    {
      id: 2,
      title: "C1 Client Deliverable POSTHQ1",
    },
  ],
}

export const exceptionsData = {
  exceptions: [
    {
      id: 1,
      title: "Unsuccessful 30 Estimates failing",
      date: "01-07-2020 ",
    },
    {
      id: 2,
      title: "Unsuccessful 30 Estimates failing",
      date: "01-06-2020 ",
    },
    {
      id: 3,
      title: "Unsuccessful 30 Estimates failing",
      date: "01-05-2020 ",
    },
    {
      id: 4,
      title: "Unsuccessful 23 Estimates failing",
      date: "01-04-2020 ",
    },
    {
      id: 5,
      title: "Unsuccessful 23 Estimates failing",
      date: "01-03-2020 ",
    },
    {
      id: 2,
      title: "Successful ingestion from SBMS",
      date: "01-02-2020 ",
    },
    {
      id: 1,
      title: "Successful ingestion from SBMS",
      date: "01-01-2020 ",
    },
  ],
}

export const standardsData = {
  data: [
    {
      id: 1,
      lob: 1,
      subchannel: 1,
      channel: 1,
      market: 1,
      demo: 1,
      col1: null,
      col2: 0.46,
    },
    {
      id: 2,
      lob: 2,
      subchannel: 2,
      channel: 2,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.55,
    },
    {
      id: 3,
      lob: 1,
      subchannel: 6,
      channel: 4,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.52,
    },
    {
      id: 4,
      lob: 2,
      subchannel: 1,
      channel: 1,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.55,
    },
    {
      id: 5,
      lob: 3,
      subchannel: 2,
      channel: 2,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.55,
    },
    {
      id: 6,
      lob: 1,
      subchannel: 2,
      channel: 2,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.55,
    },
    {
      id: 7,
      lob: 1,
      subchannel: 1,
      channel: 1,
      market: 2,
      demo: 1,
      col1: null,
      col2: 0.55,
    },
    {
      id: 8,
      lob: 1,
      subchannel: 2,
      channel: 2,
      market: 3,
      demo: 1,
      col1: 0.49,
      col2: 0.58,
    },
    {
      id: 9,
      lob: 1,
      subchannel: 2,
      channel: 2,
      market: 3,
      demo: 1,
      col1: 0.49,
      col2: 0.58,
    },
    {
      id: 10,
      lob: 1,
      subchannel: 2,
      channel: 2,
      market: 3,
      demo: 1,
      col1: 0.49,
      col2: 0.58,
    },
    {
      id: 11,
      lob: 1,
      subchannel: 3,
      channel: 3,
      market: 3,
      demo: 1,
      col1: 1,
      col2: 1,
    },
    {
      id: 12,
      lob: 1,
      subchannel: 4,
      channel: 3,
      market: 3,
      demo: 2,
      col1: 1,
      col2: 1,
    },
    {
      id: 13,
      lob: 1,
      subchannel: 5,
      channel: 3,
      market: 3,
      demo: 3,
      col1: 1,
      col2: 1,
    },
    {
      id: 14,
      lob: 1,
      subchannel: 1,
      channel: 1,
      market: 4,
      demo: 1,
      col1: null,
      col2: 0.5,
    },
    {
      id: 15,
      lob: 1,
      subchannel: 1,
      channel: 1,
      market: 5,
      demo: 1,
      col1: null,
      col2: 0.49,
    },
    {
      id: 16,
      lob: 3,
      subchannel: 2,
      channel: 2,
      market: 6,
      demo: 1,
      col1: 0.4,
      col2: 0.51,
    },
    {
      id: 17,
      lob: 1,
      subchannel: 2,
      channel: 2,
      market: 6,
      demo: 1,
      col1: 0.4,
      col2: 0.51,
    },
    {
      id: 18,
      lob: 1,
      subchannel: 1,
      channel: 1,
      market: 6,
      demo: 1,
      col1: 0.4,
      col2: 0.51,
    },
    {
      id: 19,
      lob: 1,
      subchannel: 3,
      channel: 3,
      market: 6,
      demo: 2,
      col1: 1,
      col2: 1,
    },
    {
      id: 20,
      lob: 1,
      subchannel: 4,
      channel: 3,
      market: 6,
      demo: 2,
      col1: 1,
      col2: 1.27,
    },
    {
      id: 21,
      lob: 1,
      subchannel: 5,
      channel: 3,
      market: 6,
      demo: 2,
      col1: 1,
      col2: 1.27,
    },
  ],
  columns: [
    { title: "ID", field: "id", editable: "never" },
    {
      title: "LOB",
      field: "lob",
      lookup: {
        1: "Bank",
        2: "Financial Services",
        3: "Card",
      },
    },
    {
      title: "Subchannel",
      field: "subchannel",
      lookup: {
        1: "NA-PRINT",
        2: "NA-COM",
        3: "Streaming Audio",
        4: "Terrestrial Audio",
        5: "Traffic Audio",
        6: "Spot TV",
      },
    },
    {
      title: "Channel",
      field: "channel",
      lookup: {
        1: "Print",
        2: "Com",
        3: "Audio",
        4: "TV",
      },
    },
    {
      title: "Market",
      field: "market",
      lookup: {
        1: "ALEXANDRIA, LA",
        2: "ATLANTA",
        3: "AUSTIN",
        4: "BATON ROUGE",
        5: "BIRMINGHAM",
        6: "BOSTON [MANCHESTER]",
      },
    },
    {
      title: "Demo",
      field: "demo",
      lookup: {
        1: "A18+",
        2: "A25-49",
        3: "A25-40",
      },
    },
    { title: "A25-49", field: "col1", type: "numeric", emptyValue: "NULL" },
    { title: "A25-54", field: "col2", type: "numeric", emptyValue: "NULL" },
  ],
}

export const mediaData = [
  { id: 1, media_type: "Audio" },
  { id: 2, media_type: "Digital" },
  { id: 3, media_type: "Social" },
  { id: 4, media_type: "TVi" },
  { id: 5, media_type: "National TV" },
]
